import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="search-results"
export default class extends Controller {
  static targets = ["item"]

  connect() {
    console.log("Search results controller connected")
    this.animateItems()
  }

  // Add animation class to items after they load
  animateItems() {
    this.itemTargets.forEach(item => {
      item.classList.add('result-animation')
    })
  }

  // Scroll to top of results section on mobile after pagination
  scrollToTop(event) {
    if (window.innerWidth < 768) {
      const header = this.element.querySelector('.search-result-header')
      if (header) {
        header.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }
}
